import { Button } from '@machobear/design-system'

import { useLogin } from './context'
import { LoginStepProps } from './types'

type ResetPasswordSuccessProps = Pick<LoginStepProps, 'setCurrentStep' | 't'>

const ResetPasswordSuccess: React.FC<ResetPasswordSuccessProps> = ({
  setCurrentStep,
  t
}) => {
  const { setUsername } = useLogin()

  return (
    <Button
      id="web-LoginSocial-reset-password-done-button"
      onClick={() => {
        setUsername('')
        setCurrentStep('login')
      }}
    >
      {t('b.auth.view.reset_password.back_to_login.button', 'Back to Login')}
    </Button>
  )
}

export default ResetPasswordSuccess
